import React, { Component } from 'react';
import Modal from 'react-modal';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import { withRouter } from 'react-router-dom';
import GSTAddModalUI from './GSTAddModalUI';

class GSTAddModalSF extends Component {
	constructor(props) {
		super(props);
		this.state = {
			successMsg: null,
			errorList: null,
			submitted: false,
			gstNumber: '',
			gstNumberError: null,
			state: '',
			stateError: null,
		};
	}

	render() {
		return (
			<GSTAddModalUI
				context={this.props.context}
				errorList={this.state.errorList}
				successMsg={this.state.successMsg}
				setErrorList={this.setErrorList}
				createMode={this.props.addMode}
				submitted={this.state.submitted}
				onSubmit={this.onSubmit}
				onCancelCreate={this.onCancelCreate}

				gstNumber={this.state.gstNumber}
				onGstNumberChange={(event) => this.setState({ gstNumber: event.target.value })}
				gstNumberError={this.state.gstNumberError}
				setGstNumberError={(error) => this.setState({ gstNumberError: error })}

				state={this.state.state}
				onStateChange={(event) => this.setState({ state: event.target.value })}
				stateError={this.state.stateError}
				setStateError={(error) => this.setState({ stateError: error })}
			/>
		);
	}

	componentDidMount() {
		Modal.setAppElement('body');
	}

	onCancelCreate = () => {
		this.setState({
			submitted: false,
			errorList: null,
		});
		this.props.onCancelCreate();
	}

	onSubmit = () => {
		if (this.state.submitted) return;

		const { gstNumber, state } = this.state;
		if (!gstNumber || !state) {
			this.setState({
				gstNumberError: !gstNumber ? 'GST number is required' : null,
				stateError: !state ? 'State is required' : null,
				submitted: false,
			});
			return;
		}

		this.setState({
			successMsg: null,
			errorList: [],
			submitted: true,
		});

		RestApiUtils.post(
			this.props.context,
			`/api/su/accounts/${this.props.account.accountId}/gst`,
			this.onSubmitCallback,
			{
				gstNumber: this.state.gstNumber,
				state: this.state.state,
			}
		);
	}

	onSubmitCallback = (response) => {
		let errorList = [];
		if (response.errorList) {
			errorList = response.errorList.map((error) => error.message);
		}

		this.setState({
			successMsg: response.success || null,
			errorList: errorList,
			submitted: false,
		});

		if (errorList.length === 0) {
			setTimeout(() => {
				this.setState({ successMsg: null });
				this.props.onCancelCreate();
				this.props.onRefreshClick();
			}, 1000);
		}
	}

	setErrorList = (errorList) => {
		this.setState({ errorList: errorList });
	}
}

export default withRouter(GSTAddModalSF);
